import { format, parse } from 'date-fns';
import { zonedTimeToUtc } from 'date-fns-tz';

export const isDateBeforeNow = (value: string) => {
  const date = new Date(value);
  const utcDate = zonedTimeToUtc(date, 'Etc/UTC');
  return utcDate.valueOf() < new Date().valueOf();
};

export const formatExpDate = (value: string) => {
  const expDate = value.includes('/')
    ? parse(value, 'MM/yy', new Date())
    : parse(value, 'MMyy', new Date());

  return format(expDate, 'MMyy');
};

export const getExpDateForEncryptedData = (expiryDuration: number) => (
  (new Date(Date.now() + expiryDuration))
    .toLocaleString(
      'en-US',
      {
        month: '2-digit',
        day: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: 'UTC',
      }
    )
    .replace(',', '')
);
